export default __webpack_public_path__ + "static/media/dashboard.de33105d.jpg";